import styled from "styled-components";
import { Color, Font, breakpoints } from "@/shared/Constants";

export const NumerologyContainer = styled.div``